/** KYB upload limits — keep in sync with backend KYB_DOC_MAX_BYTES (10MB). */
export const KYB_MAX_BYTES = 10 * 1024 * 1024;

const KYB_ALLOWED_MIME = new Set([
  "application/pdf",
  "image/jpeg",
  "image/png",
  "image/webp",
  "image/heic",
  "image/heif",
]);

const KYB_ALLOWED_EXT = /\.(pdf|jpe?g|png|webp|heic|heif)$/i;

export function formatBytes(n) {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}

export function validateKybFile(file) {
  if (!file) return "Choose a file to upload";
  if (file.size === 0) return "This file is empty";
  if (file.size > KYB_MAX_BYTES) {
    return `File is too large (${formatBytes(file.size)}). Maximum size is ${formatBytes(KYB_MAX_BYTES)}.`;
  }
  const type = (file.type || "").toLowerCase();
  const name = file.name || "";
  const extOk = KYB_ALLOWED_EXT.test(name);
  if (type) {
    if (!KYB_ALLOWED_MIME.has(type) && !extOk) {
      return "Unsupported file type. Use PDF, JPEG, PNG, or WebP.";
    }
  } else if (!extOk) {
    return "Unsupported file type. Use PDF, JPEG, PNG, or WebP.";
  }
  return null;
}

/** Encode file as base64 without blowing the JS call stack on large files. */
export async function fileToBase64(file) {
  const buffer = await file.arrayBuffer();
  const bytes = new Uint8Array(buffer);
  let binary = "";
  const chunkSize = 0x8000;
  for (let i = 0; i < bytes.length; i += chunkSize) {
    binary += String.fromCharCode(...bytes.subarray(i, i + chunkSize));
  }
  return btoa(binary);
}
